import { StorageService } from './storage.service';
import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { DialogService } from './dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NavigationService } from './navigation.service';
import { PATHS } from '../../shared/models/paths';

@Injectable({
  providedIn: 'root',
})
export class StorageStateService {

  public readonly folderId = signal<string>(undefined);
  private readonly dialogService = inject(DialogService);
  private readonly storageService = inject(StorageService);
  private readonly navigationService = inject(NavigationService);


  private refreshTrigger = signal(false);
  public readonly error = signal<HttpErrorResponse>(undefined);

  constructor() {
    effect(() => {
      const error = this.folderIdResource.error();
      if (error instanceof HttpErrorResponse) {
        this.error.set(error);
        if (error.status !== 403) {
          this.dialogService.showError('Errore durante l\'accesso alla cartella. Ricaricare la pagina.');
          this.folderIdResource.set([]);
        } else {
          this.dialogService.showError('Accesso alla cartella non autorizzato.');
          this.navigationService.navigate(PATHS.defaultPage());
        }
      }
    });

    effect(() => {
      const error = this.folderResource.error();
      if (error instanceof HttpErrorResponse) {
        this.error.set(error);
        if (error.status !== 403) {
          this.dialogService.showError('Errore durante l\'accesso alla cartella. Ricaricare la pagina.');
          this.folderIdResource.set([]);
        } else {
          this.dialogService.showError('Accesso alla cartella non autorizzato.');
          this.navigationService.navigate(PATHS.defaultPage());
        }
      }
    });
  }

  public readonly folderIdResource = rxResource({
    request: () => {
      const currentRefresh = this.refreshTrigger();
      const folderId = this.folderId();
      if (folderId) {
        return { folderId, refreshToggle: currentRefresh };
      } else {
        return undefined;
      }
      },
    loader: (parameters) => {
      if (parameters.request.folderId) {
        return this.storageService.findFiles(parameters.request.folderId);
      }
    }
  });

  public readonly folderResource = rxResource({
    request: () => this.folderId(),
    loader: (parameters) => {
      return this.storageService.getFolder(parameters.request)
    }
  });

  public readonly folder = computed(() => this.folderResource.value());

  public readonly files = computed(() => {
    const value = this.folderIdResource.value();
    return value
      ? value.sort((a, b) => a.name.localeCompare(b.name))
      : null;
  });

  public refreshFiles(): void {
    this.refreshTrigger.update(value => !value);
  }
}
